function o() {
  return new DOMException("viewer disposed", "AbortError");
}
function t(r) {
  return typeof r == "object" && r !== null && r.name === "AbortError";
}
function e(r) {
  if (!r.traceScene) throw o();
}
export {
  t as n,
  e as r,
  o as t
};

//# sourceMappingURL=abort-qw0xAdg5.js.map